export const LOADING_PROTOTYPE_ENTRIES = 'LOADING_PROTOTYPE_ENTRIES';
export const LOADING_PROTOTYPE_ENTRIES_SUCCESS =
  'LOADING_PROTOTYPE_ENTRIES_SUCCESS';
export const LOADING_PROTOTYPE_ENTRIES_ERROR =
  'LOADING_PROTOTYPE_ENTRIES_ERROR';

export const SUBMIT_PROTOTYPE_TIME_ENTRY = 'SUBMIT_PROTOTYPE_TIME_ENTRY';
export const SUBMIT_PROTOTYPE_TIME_ENTRY_SUCCESS =
  'SUBMIT_PROTOTYPE_TIME_ENTRY_SUCCESS';
export const SUBMIT_PROTOTYPE_TIME_ENTRY_ERROR =
  'SUBMIT_PROTOTYPE_TIME_ENTRY_ERROR';

export const GET_PROTOTYPE_TIME_ENTRIES = 'GET_PROTOTYPE_TIME_ENTRIES';
export const GET_PROTOTYPE_TIME_ENTRIES_SUCCESS =
  'GET_PROTOTYPE_TIME_ENTRIES_SUCCESS';
export const GET_PROTOTYPE_TIME_ENTRIES_ERROR =
  'GET_PROTOTYPE_TIME_ENTRIES_ERROR';

export const CREATE_PROTOTYPE_TIME_ENTRY_SUCCESS =
  'CREATE_PROTOTYPE_TIME_ENTRY_SUCCESS';
export const CREATE_PROTOTYPE_TIME_ENTRY_ERROR =
  'CREATE_PROTOTYPE_TIME_ENTRY_ERROR';

export const UPDATE_PROTOTYPE_TIME_ENTRY_SUCCESS =
  'UPDATE_PROTOTYPE_TIME_ENTRY_SUCCESS';
export const UPDATE_PROTOTYPE_TIME_ENTRY_ERROR =
  'UPDATE_PROTOTYPE_TIME_ENTRY_ERROR';

export const DELETE_PROTOTYPE_TIME_ENTRY = 'DELETE_PROTOTYPE_TIME_ENTRY';
export const DELETE_PROTOTYPE_TIME_ENTRY_SUCCESS =
  'DELETE_PROTOTYPE_TIME_ENTRY_SUCCESS';
export const DELETE_PROTOTYPE_TIME_ENTRY_ERROR =
  'DELETE_PROTOTYPE_TIME_ENTRY_ERROR';

export const ADD_PROTOTYPE_TIME_ENTRY_BULK = 'ADD_TIME_ENTRY_BULK';
export const ADD_PROTOTYPE_TIME_ENTRY_BULK_SUCCESS =
  'ADD_TIME_ENTRY_BULK_SUCCESS';
export const ADD_PROTOTYPE_TIME_ENTRY_BULK_ERROR = 'ADD_TIME_ENTRY_BULK_ERROR';

export const LOADING_CALENDAR_COMPLETION = 'LOADING_CALENDAR_COMPLETION';
export const LOADING_CALENDAR_COMPLETION_SUCCESS =
  'LOADING_CALENDAR_COMPLETION_SUCCESS';
export const LOADING_CALENDAR_COMPLETION_ERROR =
  'LOADING_CALENDAR_COMPLETION_ERROR';

export const LOADING_ADD_TASK = 'LOADING_ADD_TASK';
export const LOADING_ADD_TASK_SUCCESS = 'LOADING_ADD_TASK_SUCCESS';
export const LOADING_ADD_TASK_ERROR = 'LOADING_ADD_TASK_ERROR';

export const HANDLE_PROTOTYPE_TIME_ENTRY_INPUT_CHANGE =
  'HANDLE_PROTOTYPE_TIME_ENTRY_INPUT_CHANGE';
export const UPDATE_SELECTED_DAYS = 'UPDATE_SELECTED_DAYS';
export const SET_SHOW_BULK_ENTRY_MODAL = 'SET_SHOW_BULK_ENTRY_MODAL';

export const SETUP_CATEGORIES = 'SETUP_CATEGORIES';

export const REVERT_PROTOTYPE_TIME_ENTRY = 'REVERT_PROTOTYPE_TIME_ENTRY';

export const UPSERT_PROTOTYPE_TIME_ENTRY_SUCCESS =
  'UPSERT_PROTOTYPE_TIME_ENTRY_SUCCESS';
export const UPSERT_PROTOTYPE_TIME_ENTRY_ERROR =
  'UPSERT_PROTOTYPE_TIME_ENTRY_ERROR';
